import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  TemplateRef,
} from "@angular/core";
import { locale as en } from "../i18n/en";
import { locale as fr } from "../i18n/fr";
import { locale as de } from "../i18n/de";
import { locale as pt } from "../i18n/pt";
import { CoreTranslationService } from "@core/services/translation.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { CoreConfigService } from "@core/services/config.service";
import { ColumnMode, DatatableComponent, id } from "@swimlane/ngx-datatable";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { ApiService } from "app/main/services/Api/api.service";
import { HttpErrorResponse } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "app/main/services/Toast/toast.service";

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import "jspdf-autotable";
import arabicFont from "../../../../assets/arabicFontTxt";
import * as $ from "jquery";
import domtoimage from "dom-to-image";
import { ExcelService } from "app/services/Excel/excel.service";
import { ContentHeader } from "../ContentHeader";
import { ApiResponse } from "../ApiResponse";
import { UserRow } from "./UserRow";
import { UserDto } from "./UserDto";
import { UserTicket } from "./UserTicket";
import { UserCartItemResponseDto } from "./UserCartItemResponseDto";
@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
  userStateForm: FormGroup;
  public contentHeader!: ContentHeader;
  public country = [
    { country: "Egypt", id: "1" },
    { country: "Saudi Arabia", id: "2" },
    { country: "Qatar", id: "3" },
    { country: "Oman", id: "4" },
  ];
  public accountStatus = [
    { accountStatus: "Active", id: "1" },
    { accountStatus: "Banned", id: "2" },
  ];

  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(
    private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,
    private api: ApiService,
    private formBuilder: FormBuilder,
    public toastService: ToastService,
    private excelService: ExcelService
  ) {
    this._coreTranslationService.translate(en, fr, de, pt);

    this.userStateForm = this.formBuilder.group({
      userId: ["", [Validators.required]],
      block: [, [Validators.required]],
    });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    document.getElementById("الرئيسية")?.classList.remove("active");
    document.getElementById("الفعاليات")?.classList.remove("active");
    document.getElementById("المشرفين")?.classList.remove("active");
    document.getElementById("طلبات المشرفين")?.classList.remove("active");
    document.getElementById("فئات المناسبات")?.classList.remove("active");
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById("العروض")?.classList.remove("active");
    document.getElementById("المسئولين")?.classList.remove("active");

    this.api.showAllUsers(1, 100).subscribe({
      next: (response: ApiResponse<UserDto[]>) => {
        console.log(response.data);

        this.rows = response.data.map((item: UserDto, index: number) => ({
          id: item.id,
          "#": index + 1,
          userName: item.name,
          country: item.country,
          phoneNumber: item.phoneNumber,
          email: item.email,
          isActive: item.isActive,
        }));

        this.dataToExport = response.data.map((item: UserDto, index: number) => ({
          id: item.id,
          "#": index + 1,
          userName: item.name,
          country: item.country,
          phoneNumber: item.phoneNumber,
          email: item.email,
          isActive: item.isActive == 1 ? "نشط" : "غير نشط",
        }));

        this.temp = this.rows;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });

    this.columns = [
      {
        prop: "selected",
        name: "",
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50,
      },
      { prop: "#" },
      { name: "اسم المستخدم", prop: "userName" },
      { name: "البلد", prop: "country" },
      { name: "رقم الهاتف", prop: "phoneNumber" },
      { name: "البريد الإلكترونى", prop: "email" },
      { name: "حالة الحساب", prop: "isActive" },
      { name: "", prop: "" },
    ];

    this.contentHeader = {
      headerTitle: "المستخدمين",
      actionButton: false,
    };
  }

  // search function
  search() {}

  // table
  public readonly pageLimitOptions = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 100 },
  ];
  public chkBoxSelected: UserRow[] = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows: UserRow[] = [];
  temp: UserRow[] = [];
  @ViewChild(DatatableComponent) public table!: DatatableComponent;
  ColumnMode = ColumnMode;
  columns: any[] = [];
  dataToExport: UserRow[] = [];
  customChkboxOnSelect({ selected }: { selected: UserRow[] }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : "";

    // Filter data by checking all columns
    const temp = this.temp.filter((row: UserRow) => {
      return Object.keys(row).some((key) =>
        (row as any)[key]?.toString().toLowerCase().includes(val)
      );
    });

    // Update the rows
    this.rows = temp;
    console.log(temp);
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    if (this.table) {
      this.table.limit = this.currentPageLimit;
      this.table.recalculate();
      setTimeout(() => {
        if (this.table && this.table.bodyComponent && this.table.bodyComponent.temp && this.table.bodyComponent.temp.length <= 0) {
          this.table.offset = Math.floor(
            (this.table.rowCount - 1) / this.table.limit
          );
        }
      });
    }
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  // modal
  modalOpenDefault(modalDefault: any) {
    this.modalService.open(modalDefault, {
      centered: true,
    });
  }
  modalOpenLG(modalLG: any) {
    this.modalService.open(modalLG, {
      centered: true,
      size: "lg",
    });
  }
  deletedItemId: any;
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }
  confirmDelete() {
    if (this.deletedItemId) {
      this.api.deleteUser(this.deletedItemId).subscribe({
        next: (response: ApiResponse<any>) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم الحذف بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show("خطأ أثناء الحذف ❌");
        },
      });
    }
  }

  @ViewChild("modalTickets") modalTickets!: TemplateRef<any>;

  activeTickets: UserTicket[] = [];
  expiredTickets: UserTicket[] = [];
  qrCodeUrl: string = "";
  qrSize = 110;
  selectedTicket?: UserTicket;
  currentUserId: string = "";
  openTicketsModal(userId: string) {
    this.currentUserId = userId;
    this.loadUserTickets(userId);
    this.modalService.open(this.modalTickets, { size: "lg", centered: true });
  }
  loadUserTickets(userId: string) {
    this.api.userTickets(userId).subscribe({
      next: (response: ApiResponse<UserCartItemResponseDto[]>) => {
        const list = response?.data ?? [];
        const tickets: UserTicket[] = list.map((item: UserCartItemResponseDto) => {
          return {
            id: item.id,
            userId: item.userId,
            ticketId: item.ticketId,
            numberOfTickets: item.numberOfTickets,
            numberOfScannedTickets: item.numberOfScannedTickets,
            ticket: {
              id: item.ticketId,
              name: item.ticketName ?? '',
              note: '',
              price: item.ticketPrice ?? 0,
              eventSchedule: {
                id: '',
                startTime: item.eventStartTime ?? item.lastUpdatedDate,
                endTime: item.eventEndTime ?? item.lastUpdatedDate,
                event: {
                  id: '',
                  nameAr: item.eventName ?? '',
                  nameEn: item.eventName ?? '',
                  description: '',
                  country: item.eventCountry ?? '',
                  city: item.city ?? ''
                }
              }
            }
          };
        });

        const now = new Date();
        this.activeTickets = tickets.filter(
          (ticket: UserTicket) => new Date(ticket.ticket.eventSchedule.endTime) > now
        );
        this.expiredTickets = tickets.filter(
          (ticket: UserTicket) => new Date(ticket.ticket.eventSchedule.endTime) <= now
        );
        console.log(this.expiredTickets);
      },
      error: (error: HttpErrorResponse) => {
        console.error("Error loading tickets:", error);
      },
    });
  }
  generateQR(ticket: UserTicket): string {
    this.selectedTicket = ticket;
    const qrData = ticket.id;

    if (qrData && this.qrSize) {
      this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${
        this.qrSize
      }x${this.qrSize}&data=${encodeURIComponent(qrData)}`;
      return this.qrCodeUrl;
    }
    return "";
  }

  // download files
  downloadFile(file: string) {
    if (file == "pdf") {
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير المستخدمين</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0])
                    .map((header) => `<th>${header}</th>`)
                    .join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows
                  .map(
                    (row) => `
                  <tr>
                    ${Object.keys(row)
                      .map(
                        (key) =>
                          `<td>${row[key]
                            .toString()
                            .replace(/<[^>]*>/g, "")}</td>`
                      )
                      .join("")}
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    } else if (file == "excel") {
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }

      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility

      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]);
      csvContent += headers.join(",") + "\n";

      // Add Table Rows
      this.rows.forEach((row) => {
        const rowData = headers
          .map((header) => {
            let cell = row[header] ? row[header].toString() : "";
            return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, "")}"`; // Escape quotes & remove HTML
          })
          .join(",");
        csvContent += rowData + "\n";
      });

      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "users.csv");
      document.body.appendChild(link);

      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }

  async downloadTextBasedPDF() {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a6",
    });

    // Add Arabic font
    doc.addFileToVFS("Almarai-Regular.ttf", arabicFont);
    doc.addFont("Almarai-Regular.ttf", "Almarai", "normal");
    doc.setFont("Almarai");
    doc.setR2L(false);

    // Add content manually
    doc.setFontSize(14);
    doc.text("عنوان التذكرة", 100, 15, { align: "right" });

    doc.setFontSize(10);
    doc.text("نص عربي متصل بشكل صحيح", 100, 25, { align: "right" });

    // Save PDF
    doc.save("ticket.pdf");
  }

  async downloadAsPDF() {
    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a6",
      });

      doc.addFileToVFS("Almarai-Regular.ttf", arabicFont);
      doc.addFont("Almarai-Regular.ttf", "Almarai", "normal");
      doc.setFont("Almarai");
      doc.setR2L(false);

      // 1. First prepare the HTML for proper Arabic rendering
      const ticketElement = document.querySelector(
        ".tickectToDownload"
      ) as HTMLElement;
      if (!ticketElement) {
        console.error("❌ Ticket div not found!");
        return;
      }

      // Add temporary styling for better Arabic rendering
      const originalStyles = ticketElement.getAttribute("style") || "";
      ticketElement.setAttribute(
        "style",
        originalStyles +
          "direction: rtl;" +
          "font-family: Almarai, Arial, sans-serif;" +
          "unicode-bidi: bidi-override;" +
          "word-wrap: normal;" +
          "white-space: nowrap;" +
          "text-align: right;"
      );

      // Hide elements that shouldn't be printed
      $(".no_print").hide();

      // 2. Create canvas with higher resolution
      const canvas = await html2canvas(ticketElement, {
        scale: 4, // Increased scale for better quality
        logging: false,
        useCORS: true,
        allowTaint: true,
        onclone: (clonedDoc) => {
          // Ensure cloned elements also have RTL styling
          const clonedElement = clonedDoc.querySelector(".tickectToDownload");
          if (clonedElement) {
            console.log(clonedElement);
            clonedElement.setAttribute(
              "style",
              "direction: rtl;" +
                "font-family: Almarai, Arial, sans-serif;" +
                "unicode-bidi: bidi-override;" +
                "word-wrap: normal;" +
                "white-space: nowrap;" +
                "text-align: right;"
            );
          }
        },
      });
      // console.log(canvas);
      // 5. Add image to PDF with proper dimensions
      const imgWidth = doc.internal.pageSize.getWidth() - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      doc.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight);

      // 6. Save PDF
      const now = new Date();
      const current =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      doc.save("ticket_" + current + ".pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      this.toastService.show("حدث خطأ أثناء إنشاء التذكرة ❌");
    } finally {
      // Restore original state
      $(".no_print").show();
      const ticketElement = document.querySelector(
        ".tickectToDownload"
      ) as HTMLElement;
      ticketElement.removeAttribute("style");
    }
  }

  async downloadAsPNG(str: string) {
    try {
      console.log(str);
      const ticketElement = document.querySelector(`.${str}`) as HTMLElement;

      if (!ticketElement) {
        console.error("❌ Ticket div not found!");
        return;
      }

      // Apply temporary styling
      ticketElement.classList.add("arabic-text");
      $(".no_print").hide();

      // Generate PNG using dom-to-image
      const dataUrl = await domtoimage.toPng(ticketElement, {
        quality: 1,
        bgcolor: "#ffffff",
        style: {
          direction: "rtl",
          "font-family": "Almarai, Arial, sans-serif",
        },
      });

      // Create download link
      const link = document.createElement("a");
      link.download = `ticket_${new Date().toISOString().slice(0, 10)}.png`;
      link.href = dataUrl;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating PNG:", error);
      this.toastService.show("حدث خطأ أثناء إنشاء صورة التذكرة ❌");
    } finally {
      // Cleanup
      $(".no_print").show();
      const ticketElement = document.querySelector(`.${str}`) as HTMLElement;
      ticketElement?.classList.remove("arabic-text");
    }
  }

  // printTicket() {
  //   const ticketElement = document.querySelector('.tickectToDownload') as HTMLElement;
  //   if (!ticketElement) {
  //       console.error("❌ Ticket div not found!");
  //       return;
  //   }
  //   // Open a new print window
  //   const printWindow = window.open('', '_blank');
  //   if (!printWindow) {
  //       console.error("❌ Unable to open print window!");
  //       return;
  //   }
  //   // Get all stylesheets (external & inline)
  //   let styles = "";
  //   document.querySelectorAll("link[rel='stylesheet'], style").forEach((style) => {
  //       styles += style.outerHTML; // ✅ Copy styles
  //   });

  //   printWindow.document.write(`
  //       <html>
  //           <head>
  //               <title>تذكرة الحجز</title>
  //               ${styles} <!-- ✅ Inject all styles -->
  //               <style>
  //                   body {
  //                       direction: rtl; /* ✅ Fix: Apply RTL globally */
  //                       font-family: 'Amiri', serif; /* ✅ Add Arabic-friendly font */
  //                       text-align: right;
  //                   }
  //                   .ticket {
  //                       background-color: #F3F3F3 !important;
  //                       border-radius: 15px !important;
  //                       position: relative !important;
  //                       overflow: hidden !important;
  //                       padding: 20px !important;
  //                       margin: 10px !important;
  //                   }
  //                   .tickectToDownload {
  //                       background-color: #F3F3F3 !important;
  //                       border-radius: 15px !important;
  //                       position: relative !important;
  //                       overflow: hidden !important;
  //                   }
  //                   .bg-success {
  //                       background-color: #3F8260 !important;
  //                   }
  //                   .badge {
  //                       font-size: 14px;
  //                       font-weight: 400;
  //                       color: #fff;
  //                       border-radius: 19px;
  //                   }
  //                   h5 {
  //                       font-size: 28px;
  //                       font-weight: 700;
  //                       color: #3F8260;
  //                       margin-top: 50px;
  //                   }
  //                   .location-time-text {
  //                       font-size: 25px;
  //                       font-weight: 700;
  //                       color: #404440;
  //                   }
  //                   .time, .location {
  //                       font-size: 20px;
  //                       font-weight: 400;
  //                       color: #595D59;
  //                       padding-top: 10px;
  //                   }
  //                   .status {
  //                       font-size: 14px;
  //                       font-weight: bold;
  //                   }
  //                   p {
  //                       margin: 0;
  //                       font-size: 25px;
  //                   }
  //                   .row {
  //                     display: flex;
  //                     flex-wrap: wrap;
  //                     margin-left: -1rem;
  //                     margin-right: -1rem;
  //                   }
  //                   .col-md-8 {
  //                       flex: 0 0 66.66666667%;
  //                       max-width: 66.66666667%;
  //                   }
  //                   .col-md-4 {
  //                       flex: 0 0 33.33333333%;
  //                       max-width: 33.33333333%;
  //                       margin-bottom: 20px;
  //                   }
  //                   img{
  //                     width: 80% !important;
  //                   }
  //               </style>
  //           </head>
  //           <body>
  //               ${ticketElement.outerHTML} <!-- ✅ Copy ticket content -->
  //               <script>
  //                   window.onload = function() {
  //                       window.print();
  //                       setTimeout(() => window.close(), 500);
  //                   };
  //               </script>
  //           </body>
  //       </html>
  //   `);

  //   printWindow.document.close();
  // }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString("ar-EG", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  formatTime(dateString: string): string {
    const date = new Date(dateString);

    // add 3 hours
    date.setHours(date.getHours() + 3);

    return date.toLocaleTimeString("ar-EG", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  changeOfferState(id: any, isBlocked: any) {
    // console.log(id)
    console.log(isBlocked);
    if (isBlocked == true) {
      this.userStateForm.patchValue({
        userId: id,
        block: true,
      });
    } else {
      this.userStateForm.patchValue({
        userId: id,
        block: false,
      });
    }
  }
  confirmChangeOfferState() {
    if (this.userStateForm.valid) {
      this.api.switchUserState(this.userStateForm.value).subscribe({
        next: (response: ApiResponse<any>) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم التعديل بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show("فعالية خطأ أثناء تغيير حالة العرض ❌");
        },
      });
    }
  }

  export() {
    const headers = {
      userName: "اسم المستخدم",
      email: "البريد الالكتروني",
      phoneNumber: "رقم الهاتف",
      country: "البلد",
      isActive: "حالة الحساب",
    };
    this.excelService.exportExcel(
      "تقرير المستخدمين",
      this.dataToExport,
      headers
    );
  }
}
